import { composeFieldPath } from '@northfork/basics'
import { CounterParty } from '../../counter-party.model'
import { InventoryType } from '../../inventory-type.model'
import { Transaction } from '../transaction'

export interface DirectTransfer extends Transaction {
  securityId?: number
  clearedDate?: string //isofull
  sourcePostDate?: string
  destPostDate?: string
  sourceClearedDate?: string
  destClearedDate?: string
  units: number
  destAccountId?: number
  xferAccountId?: number
  transferPrice?: number
  inventoryType?: InventoryType
  amount?: number
  counterParty?: CounterParty
  counterPartyId?: number
  postDate: string
  sourceAccountId?: number
  exchangeType?: string
}

export const transferField = composeFieldPath([] as TransferMappingModel[])
export interface TransferMappingModel {
  id: keyof TransferMappingRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  type: 'number' | 'string' | 'date'
  isEditable: boolean
  field: string
  value: string
  errorMessage?: string
}

export interface TransferMappingRow {
  entryDate: string
  oldCusip: string
  cwanIdentifier?: string
  sourceAccount: string
  destAccountId: string
  destinationAccount: string
  transferPrice: string
  rate: string
  units: string
  balanceUnits?: string
  inventoryType: string
  exchangeInOutType: string
  collateralBroker: string
  prepaidInterest: string
  interestDue: string
  exitFeeReceivable: string
}

export const exchangeField = composeFieldPath([] as ExchangeMappingModel[])
export interface ExchangeMappingModel {
  id: keyof ExchangeMappingRow
  validityStatus: 'valid' | 'invalid' | 'warning'
  type: 'number' | 'string' | 'date'
  isEditable: boolean
  field: string
  value: string | boolean
  errorMessage?: string
}

export interface ExchangeMappingRow {
  entryDate: string
  oldCusip: string
  oldCwanIdentifier?: string
  newCusip: string
  newCwanIdentifier?: string
  sourceAccount: string
  transferPrice: string
  rate: string
  units: string
  balanceUnits?: string
  inventoryType: string
  exchangeInOutType: string
  isConversion: boolean
  collateralBroker: string
}

export interface TransferPositionData {
  sessionReconDate: string
  assetId: string
  cwanIdentifier?: string
  securityId: number
  accountId: number
  units: number
  inventoryType?: InventoryType
  collateralBroker?: string
}

export interface GetBalanceUnitsPayload {
  date: string
  securityId: number
  accountId: number
  inventoryType?: string
  collateralBroker?: string
}

export interface GetBalanceUnitsResponse {
  balanceUnits: number
}
